var App = App || {};

App.SolrFacet = (function ($) {

    var showMoreButton = '<button type="button" class="facetShowMore" tabindex="-1">Show more</button>';
    var showLessButton = '<button type="button" class="facetShowLess" tabindex="-1">Show less</button>';
    var hfGetMoreFacets = $('#hfGetMoreFacets').val();
    var typingTimer;                // Timer identifier
    var doneTypingInterval = 500;   // Time in ms (0.5 seconds)

    return {
        init: init,
        collapseFacets: collapseFacets,
        scrollIfNotInView: scrollIfNotInView
    };

    function init() {
        $(document).on('keyup', '.js-facet-filter-box', filterBoxKeyUp);
        $(document).on('keydown', '.js-facet-filter-box', filterBoxKeyDown);
        $(document).on('search', '.js-facet-filter-box', filterBoxSearch);
        $(document).on('click', '.facetShowMore', facetShowMore);
        $(document).on('click', '.facetShowLess', facetShowLess)

        collapseFacets();
    }
    
    // On keyup, start the countdown
    function filterBoxKeyUp(e) {
        var $input = $(this);

        if (shouldNotFilter($input)) {
            return;
        }

        clearTimeout(typingTimer);
        if (e.which === 13) {
            doneTyping($input); // Pass the jQuery object of the input to doneTyping
        }
        else {
            typingTimer = setTimeout(function () {
                doneTyping($input); // Pass the jQuery object of the input to doneTyping
            }, doneTypingInterval);
        }
    }

    function shouldNotFilter($input) {
        var previousValue = $input.data('previousValue') || '';
        var currentValue = $input.val();

        return currentValue.length < 3 && previousValue.length < 3;
    }

    // On keydown, clear the countdown
    function filterBoxKeyDown() {
        clearTimeout(typingTimer);
    }

    function doneTyping($input) {
        facetFilter($input);
    }

    // On search
    function filterBoxSearch() {
        var $input = $(this);

        if (shouldNotFilter($input)) {
            return;
        }

        if ($input.val().length === 0)
        {
            facetFilter($input);
        }
    }

    function collapseFacets() {
        // retain 6 nodes on first display
        $('.js-truncate-facet-list').each(function () {
            var $parentList = $(this);
            $parentList.children('.js-facet').removeClass('hide');
            if ($parentList.children('.js-facet').length > 6) {
                var $remaining = $parentList.children('.js-facet:gt(5)');
                if ($remaining.length) {
                    $remaining.hide();
                    var parentClass = getParentClass($parentList);
                    if ($parentList.children('.facetMoreLess').length === 0) {
                        $parentList.append('<li class="facetMoreLess' + parentClass + '">' + showMoreButton + '</li >');
                    }
                }
            }
        });
    }

    function facetShowLess(event) {
        // if filter has child nodes, then need to hide/show top level nodes
        // while retaining user's manual expansions
        var $parentList = $(this).closest('.js-truncate-facet-list');
        var filtered = $parentList.find('.highlighted').length !== 0;
        var searchTerm = filtered ? '.highlighted' : '.js-facet';
        $parentList.children('.facetMoreLess').remove();
        var $visibleToHide = $parentList.children(searchTerm + ':visible:gt(5)');

        $visibleToHide.animate({ height: 'toggle' }, 200).promise().done(function () {
            var $moreLessButtons = addMoreLessListItem($parentList);
            $moreLessButtons.append(showMoreButton);
            if ($parentList.children(searchTerm + ':visible').length > 6) {
                $moreLessButtons.append(showLessButton);
            }
            scrollIfNotInView($parentList[0]);
        });

        event.preventDefault();
    }

    function scrollIfNotInView(target) {
        var rect = target.getBoundingClientRect();

        if (rect.top < 0) {
            $('html, body').animate({
                scrollTop: target.offsetTop
            }, 200);
        }
    };

    function facetShowMore(event) {
        // if filter has child nodes, then need to hide/show top level nodes
        // while retaining user's manual expansions
        var $parentList = $(this).closest('.js-truncate-facet-list');
        var filtered = $parentList.find('.highlighted').length !== 0;
        var searchTerm = filtered ? '.highlighted' : '.js-facet';
        $parentList.children('.facetMoreLess').remove();
        var $notVisible = $parentList.children(searchTerm + ':visible').last().nextAll(searchTerm + ':lt(10)');

        $notVisible.animate({ height: 'toggle' }, 200).promise().done(function () {
            if (shouldGetMoreFacets($parentList, searchTerm)) {
                loadMoreFacets($parentList);
            }
            else {
                addMoreLessButtons($parentList, searchTerm);
            }
        });

        initializeArrows($parentList, filtered);
        event.preventDefault();
    }   

    function facetFilter($input) {
        var filterValue = $input.val().toUpperCase();
        $input.data('previousValue', filterValue);
        let $parent = $input.parent();
        
        prepareFacetFilter($parent);

        if (filterValue.length >= $input.data('facetFilterCharCount')) {
            $parent.find('.js-facet .js-facet-label')
                .filter((i, e) => facetMatchesFilterValue($(e), filterValue))
                .each((i, e) => higlightMatchingText($(e), filterValue));

            initArrowsAndTruncateItems($parent, true);
            expandHighlightedItems($parent);
        } else { // If the filterValue is empty, show all li elements
            $parent.find('.js-truncate-facet-list li, .js-alert-resource-list li').show();
            collapseAllItems($parent);
            initArrowsAndTruncateItems($parent, false);
        }
    }

    function initArrowsAndTruncateItems($parent, filtered) {
        initializeArrows($parent, filtered);
        truncateItems($parent, filtered);
    }

    function prepareFacetFilter($parent) {
        // Remove any previous highlights
        $parent.find('.highlight').contents().unwrap();
        $parent.find('.js-facet').removeClass('highlighted');
        // Initially hide all list items in the parent
        $parent.find('.js-facet').hide();
        // Remove any previous more/less buttons
        $parent.find('.facetMoreLess').remove();
    }

    function facetMatchesFilterValue($labelElement, filterValue) {
        var label = $labelElement.text();
        var labelUpperCase = label.toUpperCase();
        // Check if the label contains the exact search term (filterValue) as a starting substring of any word within the label
        var hasMatch = labelUpperCase.split(' ').some((word, index, words) => {
            if (word.startsWith(filterValue)) {
                return true;
            }
            // If the word doesn't start with the search term, check if the search term starts right after a space (beginning of a word)
            var textFromCurrentWord = words.slice(index).join(' ');
            return textFromCurrentWord.startsWith(filterValue);
        });

        return hasMatch;
    }

    function higlightMatchingText($labelElement, filterValue) {
        $labelElement.parents('li').show();
        $labelElement.parents('.collections-child-list').removeClass('hide');
        $labelElement.parents('.bookparttitle-child-list').removeClass('hide');
        var label = $labelElement.text();

        $labelElement.parents('.js-taxonomy-label-wrap').children('.js-taxonomy-icon').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        $labelElement.parents('.js-collection-item').find('.js-collection-arrow-icon').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        $labelElement.parents('.js-bookparttitle-item').find('.js-bookparttitle-arrow-icon').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        
        var regex = new RegExp("(\\W|^)" + filterValue, "gi");

        // Highlight the matching text that starts with filterValue
        var highlighted = label.replace(regex, function (match) {
            return "<span class='highlight'>" + match + "</span>";
        });

        $labelElement.html(highlighted);
        $labelElement.parents('li').addClass('highlighted');
    }

    function expandHighlightedItems($parent) {
        // Only select and expand child lists that have highlighted items
        $parent.find('.js-taxonomy-child-list').filter(function () {
            return $(this).find('.js-taxonomy-child-list-item.highlighted').length > 0;
        }).removeClass('hide');
        $parent.find('.js-taxonomy-icon').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
    }

    function collapseAllItems($parent) {
        $parent.find('.js-taxonomy-child-list').not($('.taxonomy-lvl-0')).addClass('hide');
        $parent.find('.js-taxonomy-icon').removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
        $parent.find('.collections-child-list').addClass('hide');
        $parent.find('.bookparttitle-child-list').addClass('hide');
        $parent.find('.js-collection-arrow-icon').removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
        $parent.find('.js-bookparttitle-arrow-icon').removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');

        SCM.BookPartTitleFacet.toggleBookPartTitleParent();
        SCM.CollectionFacet.toggleCollectionParent();
    }

    function truncateItems($parent, filtered) {
        const maxItemsToShow = 6;
        const searchTerm = filtered ? '.highlighted' : '.js-facet';

        $parent.find('.js-truncate-facet-list').each(function () {
            var $parentList = $(this);
            var $items = $parentList.children(searchTerm);

            // Hide items that exceed the maxItemsToShow limit
            $items.filter((index) => index >= maxItemsToShow).hide();

            // Append the "Show more" button if necessary
            if ($items.length > maxItemsToShow && $parentList.find('.facetMoreLess').length === 0) {
                var parentClass = getParentClass($parentList);
                $parentList.append('<li class="facetMoreLess' + parentClass + '">' + showMoreButton + '</li>');
            }
        });
    }

    function initializeArrows($parent, filtered) {
        $parent.find('.js-taxonomy-child-list-item').each(function () {
            var $this = $(this);

            // check if any visible child items exist
            var hasVisibleChildren = filtered
                ? $this.find('.js-taxonomy-child-list-item').hasClass('highlighted')
                : $this.find('.js-taxonomy-child-list-item').length !== 0;

            // show or hide the icon based on whether visible children exist
            $this.find('.js-taxonomy-parent-arrow').toggle(hasVisibleChildren);
        });
    }

    function getParentClass($parentList) {
        return $parentList.hasClass('taxonomy-child-list') ? ' taxonomy-label-wrap' :
            ($parentList.hasClass('sf-facet-list-collection') ? ' collection-facet-wrap' : '');
    }

    function addMoreLessListItem($parentList) {
        var parentClass = getParentClass($parentList);
        $parentList.append('<li class="facetMoreLess' + parentClass + '"></li>');
        return $parentList.children('.facetMoreLess');
    }

    function addMoreLessButtons($parentList, searchTerm) {
        var $moreLessButtons = addMoreLessListItem($parentList);
        if ($parentList.children(searchTerm + ':not(:visible)').length) {
            $moreLessButtons.append(showMoreButton);
        }
        $moreLessButtons.append(showLessButton);
    }

    function shouldGetMoreFacets($parentList, searchTerm) {
        const getMoreFacetsIsEnabled = hfGetMoreFacets === 'True';
        const hiddenFacetsExist = $parentList.children(searchTerm + ':not(:visible)').length === 0;

        return getMoreFacetsIsEnabled && hiddenFacetsExist;
    }

    function loadMoreFacets($parentList) {
        // Check if the last list item is the last remaining facet
        var $lastLi = $parentList.children('li.js-facet').last();
        var hasLastFacetClass = $lastLi.hasClass('js-last-facet');

        // Getting the facet field, so we can check if we should try to get more facets
        var listClasses = $parentList.children('li').first().attr('class').split(' ');
        var facetName = listClasses
            .filter(f => f.startsWith('js-facet-'))
            .map(f => f.split('js-facet-')[1])
        [0];
        var shouldGetMoreFacets = ['journal', 'type', 'category', 'section'].includes(facetName);

        if (shouldGetMoreFacets && !hasLastFacetClass) {
            addMoreFacetsToList($parentList, facetName);
        }
        else {
            var filtered = $parentList.find('.highlighted').length !== 0;
            var searchTerm = filtered ? '.highlighted' : '.js-facet';
            addMoreLessButtons($parentList, searchTerm);
        }
    }
    
    function addMoreFacetsToList($parentList, facetName) {
        var queryString = window.location.search;
        var offset = $('.js-facet-' + facetName).length;
        var settings = $.extend(SCM.SearchResults.defaults, {});
        var ajaxUrl = '/' + settings.controller + '/GetMoreFacets/' + settings.instanceName;
        if (typeof settings.baseSiteUrl !== 'undefined' && settings.baseSiteUrl !== '') {
            ajaxUrl = '//' + settings.baseSiteUrl + ajaxUrl;
        }
        ajaxUrl += queryString + '&facetOffset=' + offset + '&facetFieldName=' + facetName;

        SCM.Ajax.post(ajaxUrl)
            .expectJson()
            .then(function (data) {
                var canGetMoreFacets = false;
                if (data.length !== undefined && data.length > 0) {

                    //If the response has 31 items, it means we can still getting more facets. We'll remove the last item because we only want to show 30 items.
                    if (data.length === 31) {
                        data.pop();
                        canGetMoreFacets = true;
                    }

                    //Append Data Items
                    if (facetName === 'category') {
                        addLinkFacets(data, $parentList);
                    }
                    else {
                        addCheckboxFacets(data, $parentList);
                    }
                }

                if (!canGetMoreFacets) {
                    var $lastLi = $parentList.children('li.js-facet').last();
                    $lastLi.addClass('js-last-facet');
                }

                //Show more/less buttons
                addMoreLessButtons($parentList);
            })
            .catch(function () {
                //Show more/less buttons
                addMoreLessButtons($parentList);
            });
    }

    function addCheckboxFacets(data, $parentList) {
        data.forEach(function (facet) {
            var listItemClasses = $parentList.children('li').first().attr('class');;
            var listItem = $('<li>')
                .addClass(listItemClasses)
                .attr('role', 'option');

            var checkBox = $('<input>').attr({
                type: 'checkbox',
                id: facet.chkName,
                class: 'chkSelect',
                'data-redirect-url': facet.DataUrl,
                checked: facet.Checked,
                tabindex: -1
            });

            var label = $('<label>').attr('for', facet.chkName).text(' ' + facet.Title + ' ');

            var countSpan = $('<span>').addClass('sf-count').text('(' + facet.Count + ')');

            listItem.append(
                checkBox,
                label,
                countSpan
            );

            $parentList.append(listItem);

            // Hide the newly added list item
            listItem.hide();
        });
    }

    function addLinkFacets(data, $parentList) {
        data.forEach(function (facet) {
            var listItem = $('<li>')
                .addClass('sf-facet js-facet')
                .attr('role', 'option');

            var link = $('<a>').addClass('js-sf-facet__link')
                .attr('href', '#')
                .attr('data-url', facet.DataUrl)
                .attr('tabindex', -1)
                .text(facet.Title);

            var countSpan = $('<span>').addClass('sf-count').text('(' + facet.Count + ')');

            listItem.append(
                link,
                countSpan
            );

            $parentList.append(listItem);

            // Hide the newly added list item
            listItem.hide();
        });
    }
})(jQuery);